import styled from "styled-components";

const StyledExternalLink = styled.a`
  color: inherit;
  text-decoration: none;
`;

export default StyledExternalLink;
